import define1 from "./e93997d5089d7165@2303.js";

function _1(md){return(
md`# Multi Auto Select

A selector of multiple items with an autocomplete search box. Based on [@jahkenas/inputs](/@jashkenas/inputs), also submitted as a suggestion there. See also my [search-checkbox](https://observablehq.com/@john-guerra/search-checkbox)

~~~js
import {multiAutoSelect} from "@john-guerra/multi-auto-select"
~~~

Thanks @kasiviswanath for these enhancements: 

- Added draggable feature to re-order the selected element
- Added nested selection argument to re-render inner element on each selection

Example:`
)}

function _mas(multiAutoSelect,states){return(
multiAutoSelect({
  options: states,
  placeholder: "Select some US states . . .",
  value: ["California", "Washington", "Alabama"],
  label: "State"
})
)}

function _3(md){return(
md`## A more complex example 

Following example helps to select states along with gender. 

Gender changes by **clicking** the selected states`
)}

function _statewrtgender(multiAutoSelect,states,postRender){return(
multiAutoSelect({
  options: states,
  placeholder: "Select some US states . . .",
  value: ["California", "Washington", "Alabama"],
  postRender: postRender({ options: ["🚹", "🚺", "⚧️"] }) // Custom function for rendering
})
)}

function _5(md){return(
md`These are the selected states`
)}

function _6(statewrtgender){return(
statewrtgender
)}

function _7(md){return(
md`And these the selected orders for each state`
)}

function _8(statewrtgender,$0)
{
  statewrtgender;
  return $0.order;
}


function _9(md){return(
md`And this is a custom function that controls the displaying and changing of order`
)}

function _postRender(html,Event){return(
function postRender({ options = ["♂️", "♀️", "⚧️"] } = {}) {
  return (d, button, ele, fm) => {
    // Initialize the sort order
    if (!fm.order) {
      fm.order = [];
    }

    //Get order when there is a change in order or selection
    function getOrder() {
      fm.order = [];
      console.log("node count", fm[1].childNodes);
      for (let child of fm[1].childNodes) {
        fm.order.push(child.childNodes[1]?.nodeValue);
      }
    }

    // Update the order if the elements are re-ordered
    fm.output.addEventListener("update", () => getOrder());

    ele.addEventListener("click", () => {
      // Initialize the nested option only when the length is 2
      if (ele.childNodes.length === 2) {
        //Get random option
        let randoption = options[Math.floor(Math.random() * options.length)];
        //Insert before the delete button
        ele.insertBefore(html`${randoption}`, button);
        fm.order.push(randoption);
        fm.dispatchEvent(new Event("input", { bubbles: true }));

        return;
      }
      // Get the new option
      let newoption =
        (options.indexOf(ele.childNodes[1]?.nodeValue) + 1) % options.length;
      ele.removeChild(ele.childNodes[1]);
      ele.insertBefore(html`${options[newoption]}`, button);
      fm.dispatchEvent(new Event("input", { bubbles: true }));
      getOrder();
    });
    // For the 1st time initialization
    ele.click();
  };
}
)}

function _states(usa){return(
usa.objects.states.geometries.map((d) => d.properties.name)
)}

function _12(md){return(
md`## Passing objects

You can also pass objects with an attached accessor using \`attr\``
)}

function _eg2(multiAutoSelect,objects){return(
multiAutoSelect({ options: objects, attr: (d) => d.name })
)}

function _objects(){return(
[
  { id: 1, name: "John" },
  { id: 2, name: "Alexis" },
  { id: 3, name: "Guerra" },
  { id: 4, name: "Gomez" }
]
)}

function _15(eg2){return(
eg2
)}

function _multiAutoSelect(DOM,Event,html,Sortable,input){return(
function multiAutoSelect(config = {}) {
  const {
    value,
    title,
    description,
    disabled,
    autocomplete = "off",
    placeholder,
    size,
    options,
    label = "",
    list = DOM.uid("autoSelect").id,
    attr = (d) => d, // an accessor on what attribute of the object to use
    postRender = (d) => d // A function called after each element has been rendered, receives:
    // d: datum
    // button: the button used for deleting
    // ele: the html element
    // fm: the overall widget, useful for changing the return value of the widget using fm.value
    
  } = Array.isArray(config) ? { options: config } : config;

  const optionsMap = new Map(options.map((o) => ["" + attr(o), o])); // We need the map with strings

  const onAction = (fm) => {
    const addToSelected = (d) => {
      if (
        optionsMap.has(fm.input.value) && // It is an option
        fm.value.map((d) => "" + d).indexOf(fm.input.value) === -1 // If it hasn't been selected.  Need to convert to strings to do the comparison for numbers
      ) {
        fm.value.push(optionsMap.get(fm.input.value));
        renderSelection();
        fm.input.value = "";
        fm.dispatchEvent(new Event("input", { bubbles: true }));
      }
    };
    const renderSelected = (d) => {
      const button = html`<button type="button" style="margin:0px; padding:0px;">✖️</button>`;
      const ele = html`<span style="display: inline-block; margin: 7px 2px; border: solid 1px #ccc; border-radius: 5px;padding: 3px 6px; cursor:move; box-shadow: 1px 1px 1px #777; background: white">${attr(
        d
      )} ${button}</span>`;
      button.addEventListener("click", (e) => {
        fm.value.splice(fm.value.indexOf(d), 1);
        // remove the element directly
        ele.remove();
        fm.dispatchEvent(new Event("input", { bubbles: true }));
        fm.input.focus();
      });

      // Highlight the dragging element position
      ele.addEventListener("dragover", (e) => {
        ele.style["border-color"] = "orange";
      });

      // Update back to default color
      ele.addEventListener("dragleave", (e) => {
        ele.style["border-color"] = "#ccc";
      });

      // Update back to default color
      ele.addEventListener("dragend", (e) => {
        ele.style["border-color"] = "#ccc";
      });

      // Call nested selection to re-render inner elements
      postRender(d, button, ele, fm);

      return ele;
    };

    function renderSelection() {
      for (let o of fm.value) {
        //Check if the element is already selected
        if (
          ![...fm.output.childNodes]
            .map((d) => {
              // + for integer
              let data = d.firstChild?.data?.trim();
              return isNaN(+data) ? data : +data;
            })
            .includes(attr(o))
        ) {
          fm.output.appendChild(renderSelected(o));
        }
      }

      Sortable.create(fm.output);
      //Update event will be triggered when the user drag the selected components
      Sortable.utils.on(fm.output, "update", () => {
        fm.value = [...fm.output.childNodes].map((a) =>
          a.childNodes[0].nodeValue.trim()
        );
        fm.dispatchEvent(new Event("input", { bubbles: true }));
      });
    }

    fm.input.value = "";
    fm.value = value
      ? Array.isArray(value)
        ? value.filter((d) => optionsMap.has(d))
        : [value]
      : [];
    fm.onsubmit = (e) => {
      e.preventDefault();
      addToSelected();
    };
    fm.input.addEventListener("input", function (e) {
      e.stopPropagation();
      console.log("input", e);

      // Avoid adding the selection when still writing. Happens with numbers 🤷🏼‍♂️
      if (
        e.inputType === "insertReplacementText" ||
        e.inputType === undefined // triggered when selecting from the datalist
      ) {
        addToSelected();
      }
    });


    renderSelection();
  };

  const form = input({
    type: "text",
    title,
    description,
    attributes: { disabled },
    action: onAction,
    form: html`
      <form>
         ${label ? `<label>${label}</label>` : ""}
         <input name="input" type="text" autocomplete="off" 
          placeholder="${
            placeholder || ""
          }" style="font-size: 1em;" list=${list}>
          <datalist id="${list}">
              ${options.map((d) =>
                Object.assign(html`<option>`, {
                  value: attr(d)
                })
              )}
          </datalist>
          <br/>
      </form>
      `
  });

  form.output.style["margin-left"] = "0px";
  form.style["min-height"] = "2.5em";

  return form;
}
)}

function _17(md){return(
md`## Testing with numbers`
)}

function _18(multiAutoSelect,d3){return(
multiAutoSelect({ options: d3.range(20).slice(1, 20) })
)}

function _Sortable(require){return(
require("sortablejs")
)}

export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], _1);
  main.variable(observer("viewof mas")).define("viewof mas", ["multiAutoSelect","states"], _mas);
  main.variable(observer("mas")).define("mas", ["Generators", "viewof mas"], (G, _) => G.input(_));
  main.variable(observer()).define(["md"], _3);
  main.variable(observer("viewof statewrtgender")).define("viewof statewrtgender", ["multiAutoSelect","states","postRender"], _statewrtgender);
  main.variable(observer("statewrtgender")).define("statewrtgender", ["Generators", "viewof statewrtgender"], (G, _) => G.input(_));
  main.variable(observer()).define(["md"], _5);
  main.variable(observer()).define(["statewrtgender"], _6);
  main.variable(observer()).define(["md"], _7);
  main.variable(observer()).define(["statewrtgender","viewof statewrtgender"], _8);
  main.variable(observer()).define(["md"], _9);
  main.variable(observer("postRender")).define("postRender", ["html","Event"], _postRender);
  main.variable(observer("states")).define("states", ["usa"], _states);
  main.variable(observer()).define(["md"], _12);
  main.variable(observer("viewof eg2")).define("viewof eg2", ["multiAutoSelect","objects"], _eg2);
  main.variable(observer("eg2")).define("eg2", ["Generators", "viewof eg2"], (G, _) => G.input(_));
  main.variable(observer("objects")).define("objects", _objects);
  main.variable(observer()).define(["eg2"], _15);
  main.variable(observer("multiAutoSelect")).define("multiAutoSelect", ["DOM","Event","html","Sortable","input"], _multiAutoSelect);
  main.variable(observer()).define(["md"], _17);
  main.variable(observer()).define(["multiAutoSelect","d3"], _18);
  const child1 = runtime.module(define1);
  main.import("input", child1);
  main.import("usa", child1);
  main.variable(observer("Sortable")).define("Sortable", ["require"], _Sortable);
  return main;
}
